import { useEffect } from 'react';
import { getParams } from './env';
import { debounce } from 'lodash-es';
const weblog = window.weblog;
const kpn = window.__kpn_;
const fileId = window.__file_id_;
const exposeNodeMap = {};

function isInClient(el) {
  let { top, right, bottom, left } = el.getBoundingClientRect();
  let clientHeight = window.innerHeight;
  let clientWidth = window.innerWidth;
  return !(top > clientHeight || bottom < 0 || left > clientWidth || right < 0);
}

function cdnCut({ url, el }) {
  let handledUrl = url;
  const rect = el.getBoundingClientRect();
  const rawWidth = rect.width || 200;
  const rawHeight = rect.height || 200;
  const radio = window.devicePixelRatio || 2;
  if (!url) return;
  let width = parseInt(rawWidth * radio, 10);
  let height = parseInt(rawHeight * radio, 10);
  let flag = '';
  if (handledUrl.indexOf('?') > 0) {
    flag = '&';
  } else {
    flag = '?';
  }
  if (
    handledUrl.indexOf('ali-ad') > -1 ||
    handledUrl.indexOf('ali-ec') > -1 ||
    handledUrl.indexOf('ali2.a.kwimgs.com') > -1 ||
    handledUrl.indexOf('kcdn.staging.kuaishou.com') ||
    handledUrl.indexOf('a.yximgs.com')
  ) {
    handledUrl += `${flag}x-oss-process=image/resize,m_fill,w_${width},h_${height}/format,jpg/interlace,1`;
  } else if (url.indexOf('tx-ad') > -1 || url.indexOf('tx-ec') > -1) {
    handledUrl += `${flag}imageView2/1/w/${width}/h/${height}/format/jpg/interlace/1`;
  } else if (
    url.indexOf('s1.') > -1 ||
    url.indexOf('s2.') > -1 ||
    url.indexOf('eckwai.com') > -1 ||
    url.indexOf('.ecukwai.') > -1
  ) {
    handledUrl += `${flag}x-oss-process=image/resize,w_${width},h_${height},m_lfit,limit_0/auto-orient,0/quality,q_85`;
  }
  return handledUrl;
}

export function checkAllImags() {
  const imgs = document.querySelectorAll('img');
  const domLength = imgs.length;
  for (let inx = 0; inx < domLength; inx++) {
    const img = imgs[inx];
    if (img.dataset && img.dataset.src) {
      if (!img['__render__']) {
        if (isInClient(img)) {
          img.src = cdnCut({ url: img.dataset.src, el: img });
          img['__render__'] = img.dataset.src;
        }
      } else {
        if (img['__render__'] !== img.dataset.src) {
          img.src = cdnCut({ url: img.dataset.src, el: img });
          img['__render__'] = img.dataset.src;
        }
      }
    }
  }
}

export function useDomObserver() {
  useEffect(() => {
    function collectLog() {
      let domList = document.querySelectorAll('[data-weblogger]');
      domList.forEach((dom) => {
        let attr;
        try {
          const exposeString = dom.getAttribute('data-weblogger');
          attr = JSON.parse(exposeString);
          // @ts-ignore
          // 老的逻辑 ['SHOW', {action, params: {}}]
          let type = attr[0];
          let params = attr[1];
          if (typeof type === 'string') {
            switch (type) {
              case 'SHOW': {
                if (!dom['__exposed__']) {
                  const key = Math.random();
                  exposeNodeMap[key] = exposeString;
                  dom['__exposed__'] = key;
                  if (!params.page) {
                    params.page = pageParam;
                  }
                  weblog.collect(type, params);
                } else {
                  if (exposeNodeMap[dom['__exposed__']] !== exposeString) {
                    exposeNodeMap[dom['__exposed__']] = exposeString;
                    if (!params.page) {
                      params.page = pageParam;
                    }
                    weblog.collect(type, params);
                  }
                }
                break;
              }
            }
          } else {
            // 重构流程 [{triggrName: 'SHOW', params: {}, action}, {triggrName: 'CLICK', params: {}, action},]
            attr?.forEach((item) => {
              const newParams = {
                action: item.action,
                params: item.params,
              };
              switch (item.triggerTime) {
                case 'SHOW': {
                  if (!dom['__exposed__']) {
                    const key = Math.random();
                    exposeNodeMap[key] = exposeString;
                    dom['__exposed__'] = key;
                    if (!newParams.page) {
                      newParams.page = pageParam;
                    }
                    weblog.collect(item.triggerTime, newParams);
                  } else {
                    if (exposeNodeMap[dom['__exposed__']] !== exposeString) {
                      exposeNodeMap[dom['__exposed__']] = exposeString;
                      if (!newParams.page) {
                        newParams.page = pageParam;
                      }
                      weblog.collect(item.triggerTime, newParams);
                    }
                  }
                  break;
                }
                case 'CLICK': {
                  if (!dom['__binded__']) {
                    dom.addEventListener('click', function (e) {
                      const bindedParam = JSON.parse(e.currentTarget.dataset?.weblogger || '[]');
                      let clickParam = newParams;
                      if (bindedParam?.[1]?.triggerTime === 'CLICK') {
                        clickParam = {
                          action: bindedParam?.[1]?.action,
                          params: bindedParam?.[1]?.params,
                        };
                      } else if (bindedParam?.[0]?.triggerTime === 'CLICK') {
                        clickParam = {
                          action: bindedParam?.[0]?.action,
                          params: bindedParam?.[0]?.params,
                        };
                      }
                      weblog.collect(item.triggerTime, clickParam);
                    });
                    dom['__binded__'] = true;
                  }
                }
              }
            });
          }
        } catch (e) { }
      });
    }

    const thCheck = debounce(checkAllImags, 10);
    var observer = new MutationObserver(checkAllImags);
    observer.observe(document.body, {
      attributeFilter: ['data-src'],
      attributes: true,
      childList: true,
      subtree: true,
    });

    var observer2 = new MutationObserver(collectLog);
    observer2.observe(document.body, {
      attributeFilter: ['data-weblogger'],
      attributes: true,
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      window.addEventListener('scroll', thCheck);
    }, 1000);

    const pathName = location.pathname?.substring(location.pathname?.lastIndexOf('/') + 1);
    const queryObject = getParams();
    const pageParam = pathName ? `OP_ACTIVITY_FZ_${pathName}` : 'MERCHANT_FANGZHOU_ACTIVITY';
    const getNonLocalInfo = () => {
      try {
        return queryObject ? {
          ug_channel: queryObject['openFrom'],
          ug_adid: queryObject['adId']
        } : '';
      } catch (e) {
        return ''
      }
    }
    const pvParam = {
      type: 'enter',
      page: pageParam,
      params: {
        activity_name: kpn ? kpn + '' : '',
        activity_id: fileId,
        file_id: fileId,
        entry_src: queryObject ? queryObject['entry_src'] : '',
        hyId: queryObject ? queryObject['hyId'] : '',
        push_id: queryObject ? queryObject['push_id'] : '',
        non_locallife_info: getNonLocalInfo()
      },
    };
    if (queryObject['__LOG__']) {
      let extraParam = {};
      try {
        extraParam = JSON.parse(decodeURIComponent(queryObject['__LOG__']));
      } catch (e) { }
      Object.assign(pvParam.params, extraParam);
    }
    weblog?.sendImmediately('PV', pvParam);
    weblog?.collect('CUSTOM', {
      key: 'FANGZHOU_PV',
      value: {
        activity_id: fileId,
      },
    });
    return () => {
      window.removeEventListener('scroll', thCheck);
    };
  }, []);
}
